"use client";

import { Card, CardContent, CardFooter, cn } from "@saridana-core/react-ui-kit";
import { TContentCard } from "@shared/types";
import Image from "next/image";
import { ButtonLink } from "../button-link";

type Props = TContentCard & {
  className?: string;
  iconClassName?: string;
};
export function ContentCard({ title, description, buttonLink, buttonTarget, buttonText, icon, className, iconClassName }: Props) {
  return (
    <Card className={cn("text-gray-950 border-0 shadow-none", className)}>
      <CardContent className="space-y-6 md:space-y-8 p-6 md:p-9">
        {icon && icon.data && (
          <Image
            src={icon.data?.attributes?.url || ""}
            alt={icon.data?.attributes?.alternativeText || icon.data?.attributes?.name || ""}
            width={icon.data?.attributes?.width || 100}
            height={icon.data?.attributes?.width || 100}
            className={cn("w-[80px] h-[80px] md:w-[100px] md:h-[100px] rounded-2xl", iconClassName)}
          />
        )}
        <div className="space-y-3">
          <h6 className="font-bold text-2xl sm:text-[28px]">{title}</h6>
          <p className="font-normal text-lg sm:text-xl">{description}</p>
        </div>
      </CardContent>
      {buttonText && buttonLink && buttonTarget && buttonTarget && (
        <CardFooter className="pb-6 md:pb-9 px-6 md:px-9">
          <ButtonLink href={buttonLink} text={buttonText} target={buttonTarget} variant="primary" size="md" className="w-full" />
        </CardFooter>
      )}
    </Card>
  );
}
